import { Translation } from '../types';

export const lt: Translation = {
  common: {
    loading: 'Kraunama...',
    error: 'Klaida',
    cancel: 'Atšaukti',
    save: 'Išsaugoti',
    close: 'Uždaryti',
    search: 'Ieškoti',
    reload: 'Įkelti iš naujo',
    logout: 'Atsijungti',
    dashboard: 'Valdymo skydelis',
    products: 'Produktai',
    settings: 'Nustatymai',
    language: 'Kalba',
    businessHours: 'Darbo laikas',
    back: 'Grįžti',
    selectAll: 'Pasirinkti viską',
    deselectAll: 'Panaikinti pasirinkimą',
    success: 'Sėkmingai',
    selected: 'Pasirinkta',
    confirm: 'Patvirtinti',
    required: 'Privaloma',
    requiredMarker: '*',
    previous: 'Ankstesnis',
    next: 'Kitas',
    allRightsReserved: 'Visos teisės saugomos.',
  },
  auth: {
    login: 'Prisijungti',
    email: 'El. pašto adresas',
    password: 'Slaptažodis',
    loginButton: 'Prisijungti',
    loggingIn: 'Jungiamasi...',
    loginSuccess: 'Sėkmingai prisijungta',
    loginError: 'Neteisingas el. paštas arba slaptažodis',
    invalidEmail: 'Įveskite galiojantį el. pašto adresą',
    requiredFields: 'Užpildykite visus privalomus laukus',
    demoAccount: 'Demonstracinė paskyra:',
    loginDescription: 'Įveskite savo paskyros duomenis prisijungimui',
    welcomeMessage: 'Sveiki atvykę į verslo užsakymų sistemą',
    // Registration
    register: 'Registruotis',
    createAccount: 'Sukurti paskyrą',
    confirmPassword: 'Pakartoti slaptažodį',
    passwordRequirements: 'Slaptažodis turi būti bent 8 simbolių su didžiosiomis, mažosiomis raidėmis, skaičiais ir specialiais simboliais',
    passwordsDoNotMatch: 'Slaptažodžiai nesutampa',
    registrationSuccess: 'Registracija sėkminga',
    registrationDescription: 'Registruokitės verslo paskyrai',
    alreadyHaveAccount: 'Jau turite paskyrą?',
    signIn: 'Prisijunkite',
    dontHaveAccount: 'Neturite paskyros?',
    creatingAccount: 'Kuriama paskyra...',
    registrationNote: 'Pastaba:',
    registrationNotePoints: {
      erpLinking: 'Jei turite verslo paskyrą, jūsų el. paštas bus automatiškai susietas',
      companyEmail: 'Naudokite įmonės el. pašto adresą registracijai',
      contactSupport: 'Kreipkitės pagalbos, jei reikia registracijos paramos'
    },
    b2bUsers: 'Verslo paskyros naudotojai:',
    registeredEmail: 'Registruotas el. pašto adresas',
    registeredPassword: 'Registracijos metu nustatytas slaptažodis',
    b2bCustomerRequired: 'Šis el. pašto adresas nėra registruotas kaip verslo klientas. Pirmiausia susisiekite su pardavimų skyriumi.',
    b2bVerificationError: 'Nepavyko patikrinti verslo kliento statuso. Kreipkitės į palaikymo tarnybą.',
    // Password Reset
    passwordReset: 'Slaptažodžio atkūrimas',
    passwordResetDescription: 'Įveskite el. pašto adresą laikinam slaptažodžiui gauti',
    getTemporaryPassword: 'Gauti laikinąjį slaptažodį',
    processing: 'Apdorojama...',
    passwordResetComplete: 'Slaptažodis atkurtas',
    temporaryPasswordGenerated: 'Laikinasis slaptažodis sukurtas',
    temporaryPassword: 'Laikinasis slaptažodis',
    backToLogin: 'Grįžti į prisijungimą',
    securityNotice: 'Saugumo pranešimas:',
    securityNotePoints: {
      keepSecret: 'Nesidalinkite laikinuoju slaptažodžiu su kitais',
      changeAfterLogin: 'Būtinai pakeiskite slaptažodį prisijungę',
      expires24Hours: 'Laikinasis slaptažodis galioja 24 valandas'
    },
    resetNote: 'Pastaba:',
    resetNotePoints: {
      registeredEmail: 'Įveskite registruotą el. pašto adresą',
      passwordDisplayed: 'Laikinasis slaptažodis bus parodytas ekrane',
      changeRequired: 'Prisijungus būtina pakeisti slaptažodį'
    },
    copied: 'Nukopijuota',
    copySuccessMessage: 'Laikinasis slaptažodis nukopijuotas į iškarpinę.',
    forgotPassword: 'Pamiršote slaptažodį?',
    // Password Reset Email Request
    sendResetLink: 'Siųsti atkūrimo nuorodą',
    sendingEmail: 'Siunčiamas laiškas...',
    emailSent: 'Laiškas išsiųstas',
    emailSentMessage: 'Jei šis el. pašto adresas yra mūsų sistemoje, netrukus gausite slaptažodžio atkūrimo nuorodą.',
    emailNotSent: 'Laiškas neišsiųstas',
    emailSentInfo: 'Patikrinkite savo el. pašto dėžutę ir šlamšto aplanką',
    checkEmail: 'Patikrinkite el. paštą',
    emailInstructions: 'Slaptažodžio atkūrimo instrukcijos išsiųstos',
    nextSteps: 'Tolimesni veiksmai:',
    nextStepsList: {
      checkInbox: 'Patikrinkite el. pašto dėžutę ir šlamšto aplanką',
      clickLink: 'Paspauskite atkūrimo nuorodą laiške',
      linkExpires: 'Nuoroda galioja 24 valandas',
      contactSupport: 'Kreipkitės pagalbos, jei negavote laiško',
      rateLimitInfo: 'Ribota iki 3 užklausų per valandą'
    },
    // Password Reset Completion
    resetLinkSent: 'Atkūrimo nuoroda išsiųsta',
    resetSuccess: 'Slaptažodis sėkmingai atkurtas',
    passwordUpdated: 'Slaptažodis atnaujintas',
    passwordUpdateMessage: 'Jūsų slaptažodis sėkmingai atnaujintas. Dabar galite prisijungti su nauju slaptažodžiu.',
    loginWithNewPassword: 'Prisijungti su nauju slaptažodžiu',
    // Reset Token Page
    resetToken: 'Atkurti slaptažodį',
    invalidToken: 'Netinkama atkūrimo žyma',
    expiredToken: 'Atkūrimo žymos galiojimas baigėsi',
    tokenValid: 'Atkūrimo žyma galioja',
    newPassword: 'Naujas slaptažodis',
    confirmNewPassword: 'Pakartokite naują slaptažodį',
    updatePassword: 'Atnaujinti slaptažodį',
    updatingPassword: 'Atnaujinama slaptažodis...',
    passwordMismatch: 'Slaptažodžiai nesutampa',
    resetInstructions: 'Įveskite naują slaptažodį atkūrimo užbaigimui',
  },
  accountInfo: {
    title: 'Paskyros informacija',
    loading: 'Įkeliama paskyros informacija...',
    error: 'Klaida',
    errorMessage: 'Nepavyko gauti paskyros informacijos',
    back: 'Grįžti',
    basicInfo: 'Pagrindinė informacija',
    name: 'Vardas',
    email: 'El. pašto adresas',
    contactId: 'Knitido kliento ID',
    contactNumber: 'Kontaktinis numeris',
    noInfo: 'Informacijos nėra',
    companyInfo: 'Įmonės informacija',
    company: 'Įmonės pavadinimas',
    position: 'Pareigos',
    vatId: 'PVM kodas',
    billingAddress: 'Sąskaitų adresas',
    deliveryAddress: 'Pristatymo adresas',
    addressInfo: 'Adreso informacija',
    billingDescription: 'Sąskaitų ir sutarčių dokumentų adresas',
    deliveryDescription: 'Standartinis produktų pristatymo adresas',
    sameAsBilling: '※ Tas pats kaip sąskaitų adresas',
    sameAsDelivery: '※ Tas pats kaip pristatymo adresas',
    companyName: 'Įmonės pavadinimas',
    contactPerson: 'Kontaktinis asmuo',
    address: 'Adresas',
    phoneNumber: 'Telefono numeris',
    billingUsage: 'Naudojamas sąskaitoms, sutartims ir kitiems svarbiems dokumentams',
    deliveryUsage: 'Naudojamas kaip standartinis užsakytų produktų pristatymo adresas',
    alsoUsedForDelivery: 'Taip pat naudojamas pristatymui',
    accountType: 'Paskyros tipas',
    addressId: 'Adreso ID',
    // Address editing functionality
    edit: 'Redaguoti',
    editDeliveryAddress: 'Redaguoti pristatymo adresą',
    editDeliveryDescription: 'Atnaujinkite pristatymo adreso informaciją',
    newDeliveryAddress: 'Pridėti naują pristatymo adresą',
    newDeliveryDescription: 'Įveskite naujo pristatymo adreso duomenis',
    noDeliveryAddress: 'Pristatymo adresas nesukonfigūruotas',
    success: 'Sėkmingai',
    addressUpdated: 'Pristatymo adresas sėkmingai atnaujintas',
    updateError: 'Nepavyko atnaujinti pristatymo adreso',
    requiredFields: 'Užpildykite visus privalomus laukus',
    firstName: 'Vardas',
    lastName: 'Pavardė',
    streetAddress: 'Gatvės adresas',
    streetAddress2: 'Gatvės adresas 2',
    city: 'Miestas',
    country: 'Šalis',
    selectCountry: 'Pasirinkite šalį',
    searchCountry: 'Ieškoti šalies...',
    noCountryFound: 'Šalis nerasta.',
    postalCode: 'Pašto kodas',
    companyNamePlaceholder: 'Įveskite įmonės pavadinimą',
    firstNamePlaceholder: 'Vardas',
    lastNamePlaceholder: 'Pavardė',
    streetAddressPlaceholder: 'Įveskite gatvės adresą',
    streetAddress2Placeholder: 'Butas, biuras ir t.t.',
    cityPlaceholder: 'Įveskite miestą',
    postalCodePlaceholder: 'Įveskite pašto kodą',
    billingNotEditable: 'Sąskaitų adreso redaguoti negalima.',
    billingContactSupport: 'Dėl pakeitimų kreipkitės į palaikymo tarnybą.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} pristatymo adresai',
    noDeliveryAddresses: 'Nėra užregistruotų pristatymo adresų',
    defaultAddress: 'Numatytasis',
    selectDeliveryAddress: 'Pasirinkite pristatymo adresą',
    addNewAddress: 'Pridėti naują adresą',
    editAddress: 'Redaguoti adresą',
    deleteAddress: 'Ištrinti adresą',
    confirmDelete: 'Patvirtinti ištrynimą',
    confirmDeleteMessage: 'Ar tikrai norite ištrinti šį adresą? Šio veiksmo negalima atšaukti.',
    addressAddedSuccess: 'Pristatymo adresas pridėtas',
    addressDeletedSuccess: 'Pristatymo adresas ištrintas',
    deleteError: 'Nepavyko ištrinti pristatymo adreso',
    saving: 'Išsaugoma...',
    cancel: 'Atšaukti',
    saveChanges: 'Išsaugoti pakeitimus',
    selectedDeliveryAddress: 'Pasirinktas pristatymo adresas',
  },
  dashboard: {
    title: 'Verslo partneris',
    subtitle: 'Produktų užsakymo sistema',
    welcome: 'Sveiki,',
    welcomeMessage: 'Sveiki atvykę į verslo partnerių užsakymų sistemą. Čia galite užsakyti produktus.',
    productCatalog: 'Produktų katalogas',
    productCatalogDesc: 'Peržiūrėkite ir užsakykite prieinamus produktus',
    viewProducts: 'Peržiūrėti produktus',
    orderHistory: 'Užsakymų istorija',
    orderHistoryDesc: 'Peržiūrėkite ankstesnius užsakymus',
    accountSettings: 'Paskyros nustatymai',
    accountSettingsDesc: 'Tvarkykite paskyros informaciją',
    comingSoon: 'Netrukus',
    infoTitle: 'Apie naudojimą',
    orderingInfo: 'Produktų užsakymas',
    orderingDesc: 'Pasirinkite produktus iš katalogo ir nurodykite dydį bei spalvą. Atsargų informacija prieinama realiu laiku.',
    supportInfo: 'Palaikymas',
    supportDesc: 'Jei turite klausimų, susisiekite su mumis.',
    viewOrderHistory: 'Peržiūrėti užsakymų istoriją',
    viewOrders: 'Peržiūrėti užsakymus',
    accountInfo: 'Paskyros informacija',
    accountInfoDesc: 'Peržiūrėkite savo paskyros detales',
    viewDetails: 'Peržiūrėti detales',
    supportEmail: 'b2b-partner@knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Pirmadienis-Penktadienis 9:00 - 15:00 CET',
    bulkImportDesc: 'Importuokite užsakymus iš Excel/CSV failų',
    importOrders: 'Importuoti užsakymus',
  },
  products: {
    title: 'Produktų sąrašas',
    subtitle: 'Verslo partneris',
    searchPlaceholder: 'Ieškoti pagal produkto pavadinimą arba SKU...',
    productId: 'Produkto ID',
    addToCart: 'Pridėti į krepšelį',
    selectVariation: 'Pasirinkti variantą',
    price: 'Kaina',
    priceNetNotice: 'Visos kainos nurodytos be PVM',
    stock: 'Atsargos',
    color: 'Spalva',
    newProducts: 'Nauji Produktai',
    newProductBadge: 'NAUJAS',
    size: 'Dydis',
    quantity: 'Kiekis',
    total: 'Iš viso',
    cart: 'Krepšelis',
    checkout: 'Atsiskaityti',
    csvMode: 'CSV greitas režimas',
    csvInfo: 'Produktų duomenys gauti iš CSV duomenų',
    csvUploadDate: 'CSV įkėlimo data:',
    stockNote: '※ Atsargų informacija gaunama pasirinkus produkto variantus',
    noProducts: 'Produktų nerasta',
    noProductsDesc: 'Pakeiskite paieškos kriterijus arba įkelkite CSV failą greitesniam veikimui.',
    retry: 'Bandyti dar kartą',
    pagination: 'vienetai',
    variations: 'variantai',
    stockFetchError: 'Atsargų gavimo klaida',
    stockFetchFailed: 'Nepavyko gauti atsargų',
    stockFetchFailedDesc: 'Nepavyko gauti atsargų informacijos. Bus rodomas CSV atsargos.',
    stockFetched: 'Atsargų informacija gauta',
    totalStock: 'Bendros atsargos',
    noStockAll: 'Visi variantai neturi atsargų',
    noStockData: 'Negrąžinti atsargų duomenys',
    stockFetchErrorDesc: 'Įvyko klaida gaunant atsargų informaciją',
    selectionError: 'Pasirinkimo klaida',
    enterQuantity: 'Įveskite kiekį',
    addedToCart: 'Pridėta į krepšelį',
    typesAdded: ' produktų tipai pridėti',
    addToCartError: 'Klaida dedant į krepšelį',
    addToCartErrorDesc: 'Prašome bandyti dar kartą',
    loadingStock: 'Įkeliama atsargų informacija',
    csvDataInfo: 'Rodomi CSV duomenys (ne faktinės atsargos)',
    invalidDataFormat: 'Netinkamas produktų duomenų formatas',
    loadFailed: 'Nepavyko įkelti produktų duomenų',
    csvUploadComplete: 'CSV įkėlimas baigtas',
    csvLoadedDesc: ' produktų duomenys įkelti. Atsargų informacija bus gauta pasirinkus produktus.',
    searchTitle: 'Produktų paieška',
    loadingProducts: 'Įkeliami produktų duomenys',
    noProductsCsv: 'CSV duomenyse produktų nerasta. Pakeiskite paieškos kriterijus.',
    paginationDisplay: ' rodoma',
    previous: 'Ankstesnis',
    next: 'Kitas',
    selectionSummary: 'Pasirinkimo santrauka',
    selectedQuantity: 'Pasirinktas kiekis',
    items: ' vienetai',
    viewDetails: 'Peržiūrėti detales',
    productImage: 'Produkto nuotrauka',
    correspondingVariations: 'Atitinkami variantai',
    clickToEnlarge: 'Spustelėkite padidinti',
    productIdLabel: 'Produkto ID',
    colorLabel: 'Spalva',
    filterByCategory: 'Filtruoti pagal kategoriją',
    allProducts: 'Visi produktai',
    applyFilters: 'Taikyti filtrus',
    clearFilters: 'Išvalyti filtrus',
    filters: 'Filtrai',
    clearAll: 'Išvalyti viską',
  },
  categories: {
    category_21: 'Pirštinės kojinės',
    category_23: 'Nekategorizuota',
    category_24: 'Kūno drabužiai',
    category_29: 'B2B produktai',
  },
  productDetail: {
    title: 'Produkto detalės',
    backToProducts: 'Grįžti į produktus',
    productNotFound: 'Produktas nerastas',
    productNotFoundDesc: 'Nurodytas produktas neegzistuoja arba buvo pašalintas.',
    loading: 'Įkeliamas produktas...',
    imageLoadError: 'Nepavyko įkelti nuotraukų',
    noImages: 'Nuotraukų nėra',
    productDescription: 'Produkto aprašymas',
    colors: 'Spalvos',
    sizes: 'Dydžiai',
    colorCount: 'spalvos',
    sizeCount: 'dydžiai',
    variationCount: 'variantai',
    selectVariation: 'Pasirinkite variantus',
    descriptionLanguageNote: '※ Produktų aprašymai prieinami tik anglų arba vokiečių kalbomis',
  },
  colors: {
    schwarz: 'Juoda',
    weiß: 'Balta',
    grau: 'Pilka',
    rot: 'Raudona',
    blau: 'Mėlyna',
    grün: 'Žalia',
    gelb: 'Geltona',
    rosa: 'Rožinė',
    lila: 'Violetinė',
    braun: 'Ruda',
    orange: 'Oranžinė',
    beige: 'Smėlio',
    navy: 'Tamsiai mėlyna',
    dunkelblau: 'Tamsiai mėlyna',
    hellblau: 'Šviesiai mėlyna',
    dunkelgrau: 'Tamsiai pilka',
    hellgrau: 'Šviesiai pilka',
    bordeaux: 'Bordo',
    türkis: 'Turkio',
    khaki: 'Chaki',
    mint: 'Mėtinė',
    violett: 'Violetinė',
    anthrazit: 'Antracito',
    blaugrau: 'Melsva pilka',
    burgunderrot: 'Burgundiška',
    elfenbein: 'Dramblio kaulo',
    karminrot: 'Karmino',
    neongrün: 'Neoninė žalia',
    gelbgrün: 'Gelsvai žalia',
    pistazie: 'Pistacijų',
    // Angliški spalvų pavadinimai (naudojami Product ID 237 ir kt.)
    blue: 'Mėlyna',
    ivory: 'Dramblio kaulas',
    green: 'Žalia',
    gold: 'Auksinė',
    red: 'Raudona',
  },
  checkout: {
    title: 'Atsiskaitymas',
    cartReview: 'Užsakymo peržiūra',
    orderSummary: 'Užsakymo santrauka',
    shippingInfo: 'Pristatymo informacija',
    billingInfo: 'Sąskaitos informacija',
    orderNotes: 'Užsakymo pastabos',
    orderNotesPlaceholder: 'Specialūs prašymai ar pastabos...',
    contactPerson: 'Kontaktinis asmuo',
    phoneNumber: 'Telefono numeris',
    email: 'El. pašto adresas',
    company: 'Įmonė',
    address: 'Adresas',
    city: 'Miestas',
    postalCode: 'Pašto kodas',
    country: 'Šalis',
    deliveryDate: 'Pristatymo data',
    urgentDelivery: 'Skubus pristatymas (3-5 darbo dienos)',
    standardDelivery: 'Standartinis pristatymas (7-10 darbo dienų)',
    placeOrder: 'Pateikti užsakymą',
    backToCart: 'Grįžti į produktų pasirinkimą',
    requiredField: 'Privalomas laukas',
    orderTotal: 'Užsakymo suma',
    subtotal: 'Tarpinė suma',
    priceNetNotice: 'Visos kainos nurodytos be PVM',
    stockReservationNotice: 'Atsargų rezervavimas bus atliktas po užsakymo patvirtinimo.',
    stockCheckError: 'Atsargų tikrinimo klaida',
    stockCheckErrorDesc: 'Įvyko klaida tikrinant atsargas. Bandykite dar kartą.',
    shipping: 'Pristatymas',
    shippingCost: 'Pristatymo kaina',
    tax: 'Mokestis',
    orderSuccess: 'Užsakymas sėkmingas',
    orderSuccessMessage: 'Jūsų užsakymas sėkmingai pateiktas. Užsakymo numeris: {orderNumber}',
    orderNumber: 'Užsakymo numeris',
    thankYou: 'Dėkojame už užsakymą!',
    orderConfirmation: 'Jūsų užsakymas sėkmingai pateiktas.',
    orderProcessing: 'Po mūsų komandos peržiūros, atsiųsime užsakymo patvirtinimą el. paštu.',
    orderProcessingMessage: 'Jūsų užsakymas sėkmingai pateiktas. Po mūsų komandos peržiūros, atsiųsime užsakymo patvirtinimą el. paštu.',
    continueShopping: 'Tęsti apsipirkimą',
    emptyCart: 'Jūsų krepšelis tuščias',
    emptyCartMessage: 'Pridėkite produktų į krepšelį norėdami tęsti',
    stockWarning: 'Atsargų įspėjimas',
    stockWarningDesc: 'Kai kurie produktai neturi pakankamai atsargų. Pakoreguokite kiekius.',
    stockError: 'Atsargų klaida',
    stockErrorDesc: 'Yra produktų su nepakankamomis atsargomis. Pakoreguokite kiekius.',
    refreshStock: 'Atnaujinti atsargas',
    stockUpdated: 'Atsargos atnaujintos',
    stockUpdatedDesc: 'Atsargos atnaujintos - {changed} produktai pakeisti',
    stockCheckDesc: 'Palyginimo rezultatai su inventoriumi rodomi',
    stockOk: 'Atsargos OK',
    stockShortage: 'Atsargų trūkumas',
    requestedQty: 'Prašomas kiekis',
    currentStock: 'Dabartinės atsargos',
    stockShortageMsg: 'Nepakankamos atsargos. Pakoreguokite kiekį.',
    stockIssueWarning: 'Užsakymo negalima patvirtinti dėl atsargų problemų.',
    stockDataMissing: 'Atsargų duomenys gaunami. Palaukite.',
    outOfStock: 'Išparduota.',
    maxAvailable: 'Maksimaliai',
    autoRestored: 'Krepšelis atkurtas',
    autoRestoredDesc: 'Jūsų paskutinės sesijos prekės buvo atkurtos',
    maxQuantityReached: 'Pasiektas maksimalus atsargų kiekis.',
    // ERP Contact Search
    contactSearch: 'Kliento kontakto paieška',
    contactSearchDesc: 'Įveskite užsakovo el. pašto adresą kontakto informacijai gauti',
    emailAddress: 'El. pašto adresas',
    searchButton: 'Ieškoti',
    searching: 'Ieškoma',
    contactFound: 'Kontaktas rastas',
    contactNotFound: 'Kontaktas nerastas',
    contactId: 'Knitido kliento ID',
    companyName: 'Įmonė',
    contactPersonLabel: 'Kontaktinis asmuo',
    addressesFound: 'Rasti adresai',
    addressType: 'Tipas',
    addressBilling: 'Sąskaitų adresas',
    addressDelivery: 'Pristatymo adresas',
    vatSourceCompany: 'Įmonės info',
    vatSourceBilling: 'Sąskaita',
    vatSourceDelivery: 'Pristatymas',
    addressOther: 'Kitas',
    addressDetails: 'Adresas',
    loadingAddresses: 'Įkeliama adreso informacija...',
    addressRetrieved: 'Adreso informacija gauta',
    addressNotFound: 'Adreso informacija nerasta',
    addressNotFoundDesc: 'Nėra registruotos adreso informacijos. Įveskite rankiniu būdu.',
    addressError: 'Adreso gavimo klaida',
    addressErrorDesc: 'Nepavyko gauti adreso informacijos.',
    contactNotConfirmed: 'Kliento kontaktas nepatvirtintas',
    contactNotConfirmedDesc: 'Įveskite el. pašto adresą ir ieškokite kontakto.',
    searchContact: 'Ieškoti kontakto',
    inputError: 'Įvesties klaida',
    inputErrorDesc: 'Pristatymo informacija nepilna. Patikrinkite.',
    processing: 'Apdorojama...',
    erpContactSearch: 'Kliento kontakto paieška',
    contactSearchError: 'El. pašto adresas neatitinka jokio registruoto kontakto.',
    // Product Images Toggle
    showProductImages: 'Rodyti produktų nuotraukas',
    showProductImagesDesc: 'Rodyti produktų nuotraukas geresnei apžvalgai (gali padidinti įkėlimo laiką)',
    // System Registration Info
    systemRegistrationInfo: 'Jūsų kliento informacija',
    editShippingAddress: 'Redaguoti pristatymo adresą',
    systemRegistrationInfoDesc: 'Jūsų registruota verslo informacija. Kreipkitės į atstovą, jei reikia atnaujinti sąskaitų adreso detales.',
    // Order Summary
    regularPrice: 'Įprasta didmeninė kaina',
    offeredPrice: 'Siūloma kaina',
    discount: 'Nuolaida',
    b2bCustomer: 'B2B klientas',
    pattern: 'Šablonas',
    specialPriceApplied: 'Taikoma speciali kaina',
    customerClassification: 'Kliento klasifikacija',
    paymentCondition: 'Mokėjimo sąlygos',
    invoice: 'Sąskaita faktūra (NET 30)',
    prepayment: 'Išankstinis mokėjimas',
    paymentMethod: 'Mokėjimo būdas',
    invoicePayment: 'Sąskaitos apmokėjimas',
    estimatedSubtotal: 'Preliminari tarpinė suma',
    estimatedTotal: 'Preliminari suma',
    orderSummaryDisclaimer: 'Čia nurodytos kainos yra preliminarios. Gavę jūsų užsakymą, jį peržiūrėsime ir el. paštu atsiųsime privalomą užsakymo patvirtinimą su galutinėmis kainomis, pristatymo išlaidomis ir mokesčiais.',
    searchError: 'Paieškos klaida',
    searchErrorDesc: 'Įvyko klaida kontakto paieškos metu.',
    confirmDeleteItem: 'Pašalinti prekę',
    itemDeleted: 'Prekė pašalinta',
    confirmDeleteItemDesc: 'Ar tikrai norite pašalinti šią prekę iš krepšelio?',
    deleteConfirm: 'Pašalinti',
    contactNotes: 'Kontakto pastabos',
    contactNotesDesc: 'Turite klausimų ar specialių prašymų? Prašome pranešti (neprivaloma)',
    contactNotesLabel: 'Žinutė',
    contactNotesPlaceholder: 'pvz.: Produktų klausimai, specialūs reikalavimai ir t.t.',
    characters: 'simboliai',
    contactIdLabel: 'Knitido kliento ID',
    companyLabel: 'Įmonė',
    personLabel: 'Kontaktinis asmuo',
    emailLabel: 'El. paštas',
    addressTypeLabel: 'Tipas',
    destinationLabel: 'Paskirties vieta',
    // Shipping Form
    shippingTitle: 'Pristatymo informacija',
    shippingDesc: 'Įveskite produktų pristatymo adresą',
    companyRequired: 'Įmonė *',
    contactPersonRequired: 'Kontaktinis asmuo *',
    emailRequired: 'El. pašto adresas *',
    phoneRequired: 'Telefono numeris *',
    addressRequired: 'Adresas 1 *',
    address2: 'Adresas 2 (Pastatas/Kabinetas)',
    postalCodeRequired: 'Pašto kodas *',
    cityRequired: 'Miestas *',
    countryRequired: 'Šalis *',
    selectCountry: 'Pasirinkite šalį',
    shippingMethodRequired: 'Pristatymo būdas *',
    selectShippingMethod: 'Pasirinkite pristatymo būdą',
    urgentDeliveryOption: 'Skubus pristatymas (papildomi mokesčiai)',
    deliveryNotes: 'Pristatymo pastabos',
    deliveryNotesPlaceholder: 'Įveskite pristatymo laiko pageidavimus ar kitus prašymus',
    standardShipping: 'Standartinis pristatymas (3-5 darbo dienos)',
    expressShipping: 'Ekspres pristatymas (1-2 darbo dienos)',
    overnightShipping: 'Pristatymas per naktį',
    germany: 'Vokietija',
    austria: 'Austrija',
    switzerland: 'Šveicarija',
    japan: 'Japonija',
    shippingAddressLabel: 'Pristatymo adresas',
    changeDeliveryAddress: 'Keisti pristatymo adresą',
    selectDeliveryAddress: 'Pasirinkti pristatymo adresą',
    // Shipping Cost Details
    freeShipping: 'Nemokamas pristatymas',
    shippingError: 'Klaida',
    shippingZone: 'Pristatymo zona',
    remainingForFreeShipping: 'Iki nemokamo pristatymo liko {amount}',
    moreForFreeShipping: 'iki nemokamo pristatymo',
    freeShippingProgress: 'Nemokamas pristatymas nuo',
    andAboveFreeShipping: 'ir daugiau nemokamas pristatymas',
    freeShippingAchieved: 'Taikomas nemokamas pristatymas',
    threshold: 'ir daugiau',
    nextShippingTier: 'Kita pristatymo nuolaida',
    moreForDiscount: 'daugiau už',
    shippingSavings: 'pristatymo sutaupymus',
    orderAmountThreshold: 'ir daugiau už',
    specialRegionNotice: 'Taikomas specialus pristatymo regionas',
    defaultShippingApplied: 'Taikomi standartiniai pristatymo tarifai',
    requestedQuantity: 'Prašomas kiekis',
    availableQuantity: 'Turimas kiekis',
    orderSubmitError: 'Užsakymo klaida',
    orderSubmitErrorDesc: 'Nepavyko pateikti užsakymo',
    upload: {
      title: 'Importuoti Excel/CSV užsakymą',
      description: 'Įkelkite Excel arba CSV failą su užsakymo duomenimis',
      dragDropOrClick: 'Nutempkite failą čia arba spustelėkite pasirinkti',
      dropHere: 'Numeskite failą čia',
      supportedFormats: 'Palaikomi formatai: Excel (.xlsx, .xls) ir CSV (.csv)',
      maxSize: 'Maksimalus failo dydis: {size} MB',
      processFile: 'Apdoroti failą',
      processing: 'Apdorojamas failas...',
      ready: 'Failas paruoštas peržiūrai',
      readyDescription: 'Jūsų failas sėkmingai apdorotas ir paruoštas peržiūrai.',
      preview: 'Rodyti peržiūrą',
      errors: {
        fileTooLarge: 'Failas per didelis. Maksimalus dydis: {size} MB',
        invalidFileType: 'Netinkamas failo tipas. Įkelkite Excel arba CSV failą',
        uploadFailed: 'Klaida įkeliant failą',
      },
    },
    // Loading messages
    loadingPage: 'Įkeliamas puslapis...',
    loadingStock: 'Tikrinamos produktų atsargos...',
    loadingAccount: 'Įkeliama paskyros informacija...',
    loadingError: 'Įvyko klaida...',
    loadingData: 'Įkeliami duomenys',
    // Toast messages
    addressRetrievedTitle: 'Adreso informacija gauta',
    addressSetAsDelivery: ' adresas nustatytas kaip pristatymo vieta.',
    contactFoundDesc: ' buvo atpažintas.'
  },
  orderHistory: {
    title: 'Užsakymų istorija',
    searchPlaceholder: 'Ieškoti pagal užsakymo numerį arba SKU...',
    noOrders: 'Užsakymų nerasta',
    noOrdersFound: 'Atitinkančių užsakymų nerasta',
    startShopping: 'Peržiūrėti produktus',
    orderItems: 'Užsakymo prekės',
    viewDetails: 'Detalės',
    reorder: 'Užsakyti pakartotinai',
    orderDate: 'Užsakymo data',
    orderStatus: 'Būsena',
    orderTotal: 'Užsakymo suma',
    // Status translations
    statusPending: 'Laukiama apmokėjimo',
    statusProcessing: 'Apdorojama',
    statusConfirmed: 'Patvirtinta',
    statusShipped: 'Išsiųsta',
    statusDelivered: 'Pristatyta',
    statusCancelled: 'Atšaukta',
    statusReturned: 'Grąžinta',
    statusRefunded: 'Grąžinti pinigai',
    statusWarranty: 'Garantija',
    statusExchanged: 'Pakeista',
    statusRepair: 'Remontas',
    statusUnknown: 'Nežinoma',
    statusIncomplete: 'Neužbaigta',
    statusWaitingPayment: 'Laukiama mokėjimo',
    statusInPreparation: 'Ruošiama',
    statusClearedShipping: 'Paruošta siuntimui',
    statusBeingShipped: 'Siunčiama',
    statusOutgoingBooked: 'Išsiuntimo rezervacija',
    statusReturn: 'Grąžinimas',
    // Additional UI elements
    itemCount: 'prekės',
    itemCountSingular: 'prekė',
    refreshButton: 'Atnaujinti',
    errorFetchingOrders: 'Nepavyko gauti užsakymų istorijos',
    // Payment status features
    paymentStatus: 'Mokėjimo būsena',
    markAsPaid: 'Pažymėti kaip apmokėta',
    unmarkAsPaid: 'Panaikinti mokėjimo žymą',
    paidOn: 'Apmokėta',
    paymentMarked: 'Apmokėta',
    notPaid: 'Neapmokėta',
    paymentMarkedSuccess: 'Sėkmingai pažymėta kaip apmokėta',
    paymentUnmarkedSuccess: 'Mokėjimo žyma pašalinta',
    paymentUpdateError: 'Nepavyko atnaujinti mokėjimo būsenos',
    // Payment date dialog
    paymentDateTitle: 'Įvesti mokėjimo informaciją',
    paymentDateDescription: 'Įveskite mokėjimo informaciją užsakymui {orderNumber}',
    paymentDateLabel: 'Mokėjimo data',
    selectDate: 'Pasirinkti datą',
    paymentDateHelp: 'Pasirinkite datą, kada buvo atliktas banko pavedimas',
    paymentMethodLabel: 'Mokėjimo būdas',
    bankTransfer: 'Banko pavedimas',
    invoice: 'Sąskaita faktūra',
    otherPayment: 'Kitas',
    paymentReferenceLabel: 'Pavedimo pavadinimas / Nuorodos numeris',
    paymentReferencePlaceholder: 'pvz., Vardas Pavardė, Pavedimas #12345',
    paymentReferenceHelp: 'Įveskite informaciją, kuri padės sutapatinti su banko išrašais',
    notesLabel: 'Pastabos',
    notesPlaceholder: 'Įveskite papildomą mokėjimo informaciją',
    // Filter options
    filterByPaymentStatus: 'Filtruoti pagal mokėjimo būseną',
    allOrders: 'Visi užsakymai',
    paidOrders: 'Apmokėti',
    unpaidOrders: 'Neapmokėti',
    // Sorting options
    sortBy: 'Rūšiuoti pagal',
    sortByDate: 'Užsakymo data',
    sortByPaymentDate: 'Mokėjimo data',
    sortByAmount: 'Suma',
    sortByStatus: 'Būsena',
  },
  orderDetails: {
    title: 'Užsakymo detalės',
    notFound: 'Užsakymas nerastas',
    backToHistory: 'Grįžti į užsakymų istoriją',
    orderDate: 'Užsakymo data',
    orderItems: 'Užsakymo prekės',
    deliveryStatus: 'Pristatymo būsena',
    estimatedDelivery: 'Numatomas pristatymas',
    deliveredOn: 'Pristatyta',
    downloadInvoice: 'Atsisiųsti sąskaitą',
    statusDelivered: 'Pristatyta',
    statusShipped: 'Išsiųsta',
    statusConfirmed: 'Patvirtinta',
    statusCancelled: 'Atšaukta',
    errorFetchingDetails: 'Nepavyko gauti užsakymo detalių',
  },
  company: {
    name: 'Verslo partneris',
    tagline: 'Verslo partnerių sistema',
    copyright: '© 2025 Verslo partnerių sistema. Visos teisės saugomos.',
  },
  footer: {
    phone: 'Telefonas',
    email: 'El. paštas',
    countries: {
      DE: 'Vokietija',
      AT: 'Austrija',
      CH: 'Šveicarija',
      FR: 'Prancūzija',
      IT: 'Italija',
      ES: 'Ispanija',
      NL: 'Nyderlandai',
      BE: 'Belgija',
      PL: 'Lenkija',
      SE: 'Švedija',
      NO: 'Norvegija',
      FI: 'Suomija',
      DK: 'Danija',
      LT: 'Lietuva',
      LV: 'Latvija',
      EE: 'Estija',
    },
  },
  cart: {
    newCart: 'Naujas krepšelis',
    currentCart: 'Dabartinis krepšelis',
    modified: 'pakeista',
    lastSaved: 'Paskutinį kartą išsaugota',
    unsavedChanges: 'neišsaugoti pakeitimai',
    saveCart: 'Išsaugoti krepšelį',
    loadCart: 'Įkelti krepšelį',
    deleteCart: 'Ištrinti krepšelį',
    startNewCart: 'Pradėti naują krepšelį',
    savedCarts: 'Išsaugoti krepšeliai',
    cartSaved: 'Krepšelis išsaugotas',
    cartDeleted: 'Krepšelis ištrintas',
    confirmDeleteCart: 'Ištrinti krepšelį?\n\nŠio veiksmo negalima atšaukti.',
    confirmSwitchCart: 'Dabartinis krepšelis turi neišsaugotų pakeitimų.\n\nĮkeliant kitą krepšelį dabartiniai pakeitimai bus prarasti.\n\nTęsti?',
    confirmSwitchCartTitle: 'Perjungti krepšelį',
    confirmNewCart: 'Dabartinis krepšelis turi neišsaugotų pakeitimų.\n\nPradedant naują krepšelį dabartiniai pakeitimai bus prarasti.\n\nTęsti?',
    confirmNewCartTitle: 'Pradėti naują krepšelį',
    confirmClearCart: 'Išvalyti krepšelį?\n\n{count} prekės bus pašalintos.\n\nŠio veiksmo negalima atšaukti.',
    confirmClearCartTitle: 'Išvalyti krepšelį',
    autoSaved: 'Automatiškai išsaugota',
    itemsWillBeRemoved: 'prekės bus pašalintos',
    changesWillBeLost: 'pakeitimai bus prarasti',
    continueQuestion: 'Tęsti?',
    cartStatus: 'Krepšelio būsena',
    cartName: 'Krepšelio pavadinimas',
    cartNamePlaceholder: 'pvz.: Mėnesio pabaigos užsakymas',
    cartNameRequired: 'Įveskite krepšelio pavadinimą',
    saveCartDescription: 'Suteikite dabartiniam krepšeliui pavadinimą ir išsaugokite. Galėsite įkelti vėliau.',
    cancelCart: 'Atšaukti krepšelį',
    proceedToCheckout: 'Pereiti į atsiskaitymą',
    emptyCart: 'Krepšelis tuščias',
    erpDown: 'Užsakymų sistema neveikia. Bandykite dar kartą vėliau.',
    erpDegraded: 'Sistema šiuo metu nestabili. Užsakymai gali nepavykti.',
    erpDownSaveHint: 'Išsaugokite krepšelį ir užsisakykite, kai sistema bus atkurta.',
    erpSaveCart: 'Išsaugoti krepšelį',
  },
  nav: {
    dashboard: 'Pagrindinis',
    products: 'Produktai',
    orderHistory: 'Užsakymai',
    account: 'Paskyra',
    bulkImport: 'Masinis importas',
  },
  settings: {
    selectLanguage: 'Pasirinkite kalbą',
    languagePreferenceSaved: 'Jūsų pasirinkimas bus išsaugotas jūsų paskyroje būsimiems apsilankymams.',
  },
  reorder: {
    allItemsAdded: '{count} prekės pridėtos į krepšelį',
    partialSuccess: '{added} prekės pridėtos. {failed} prekių nepavyko pridėti',
    allItemsFailed: 'Nepavyko pridėti prekių į krepšelį',
    error: 'Įvyko klaida pakartotinio užsakymo metu',
    itemDiscontinued: '{name} ({color}/{size}) nebepardavinėjama',
    itemOutOfStock: '{name} ({color}/{size}) neturime sandėlyje',
    partialStock: '{name} ({color}/{size}) tik {available} vienetai',
    confirmReorder: 'Patvirtinti pakartotinį užsakymą',
    confirmReorderMessage: 'Pridėti prekes iš šio užsakymo į krepšelį?',
    addingToCart: 'Pridedama į krepšelį...',
    checkingStock: 'Tikrinamos atsargos...',
    checkoutTitle: 'Prekės pridėtos į krepšelį',
    checkoutDescription: '{count} prekės pridėtos į jūsų krepšelį. Ar norite pereiti į atsiskaitymą?',
  },
  bulkImport: {
    instructions: 'Kaip importuoti užsakymus',
    step1: 'Atsisiųskite užsakymo šablono failą',
    step2: 'Užpildykite užsakymo duomenis su SKU ir kiekiu',
    step3: 'Išsaugokite kaip Excel (.xlsx) arba CSV failą',
    step4: 'Įkelkite failą naudodami žemiau esančią formą',
    step5: 'Peržiūrėkite ir patvirtinkite užsakymą',
    downloadTemplate: 'Atsisiųsti šabloną',
    downloadExcelTemplate: 'Atsisiųsti Excel šabloną',
    downloadCsvTemplate: 'Atsisiųsti CSV šabloną',
    formatGuide: 'Failo formato vadovas',
    requiredColumns: 'Privalomi stulpeliai',
    skuDescription: 'Produkto SKU kodas',
    quantityDescription: 'Užsakymo kiekis (teigiamas sveikasis skaičius)',
    optionalColumns: 'Neprivalomi stulpeliai',
    notesDescription: 'Vidinės pastabos (pvz. PO numeris, nuoroda) - tik jūsų įrašams',
    formatNote: 'Pirmoje eilutėje turi būti stulpelių antraštės. Duomenys prasideda nuo antros eilutės.',
    parseSuccess: 'Sėkmingai apdorota {count} prekių iš failo',
    parseError: 'Apdorojimo klaida',
    validationError: 'Tikrinimo klaidos',
    validationErrorGuidance: 'Spustelėkite "{showPreviewButton}" mygtuką peržiūrėti detales.',
    warnings: 'Įspėjimai',
    itemsParsed: 'Sėkmingai apdorota {count} prekių:',
    andMore: '...ir dar {count} prekių',
    validationSummary: 'Tikrinimo santrauka',
    duplicateSKUs: 'Rasti pasikartojantys SKU',
    skuFormat: 'SKU turi būti tik raidės, skaičiai ir brūkšneliai',
    quantityRange: 'Kiekis turi būti nuo 1 iki 9999',
    maxRows: 'Maksimaliai 1000 eilučių',
    rowsSkipped: '{count} eilutės praleistos dėl klaidų',
    previewTitle: 'Užsakymo peržiūra',
    previewDescription: 'Peržiūrėkite ir redaguokite užsakymo duomenis prieš tęsdami',
    proceedToCart: 'Pridėti į krepšelį',
    // File parsing messages
    fileEmpty: 'Failas tuščias arba neturi duomenų',
    fileTooManyRows: 'Failas turi per daug eilučių ({current}). Maksimaliai leidžiama: {max}',
    invalidRowFormat: 'Netinkamas eilutės formatas',
    missingColumns: 'Trūksta privalomų stulpelių (SKU ir Kiekis)',
    missingSku: 'Trūksta SKU',
    invalidSkuFormat: 'Netinkamas SKU formatas: "{sku}" (turi atitikti šabloną: {pattern})',
    skuTooLong: 'SKU per ilgas: "{sku}" (maksimaliai 50 simbolių)',
    invalidQuantity: 'Netinkamas kiekis: "{quantity}" nėra skaičius',
    quantityTooLow: 'Kiekis per mažas: {quantity} (mažiausiai: {min})',
    quantityTooHigh: 'Kiekis per didelis: {quantity} (daugiausiai: {max})',
    notesRequired: 'Pastabų laukas privalomas',
    noValidData: 'Nerasta tinkamų duomenų. Patikrinkite failo formatą.',
    row: 'Eilutė {row}: {errors}',
    rowErrors: '...ir dar {count} klaidų',
    duplicateSkuInRows: 'Pasikartojantis SKU "{sku}" rastas eilutėse: {rows}',
    quantityExceedsMax: 'Eilutė {row}: Kiekis {quantity} viršija maksimalų leistiną ({max})',
    quantityBelowMin: 'Eilutė {row}: Kiekis {quantity} mažesnis už minimalų reikalingą ({min})',
    // Validation messages
    unsupportedFileFormat: 'Nepalaikomas failo formatas. Įkelkite CSV arba Excel failą.',
    csvParsingErrors: 'Įvyko CSV apdorojimo klaidos',
    failedToParseFile: 'Nepavyko apdoroti failo',
    failedToParseExcel: 'Nepavyko apdoroti Excel failo',
    failedToReadFile: 'Nepavyko nuskaityti failo',
    unknownError: 'Įvyko nežinoma klaida',
    totalRows: 'Viso eilučių',
    valid: 'Tinkamos',
    invalid: 'Netinkamos',
    skipped: 'Praleistos',
    // SKU validation
    skuValidationError: 'SKU tikrinimo klaida',
    skuValidationFailed: 'Nepavyko patikrinti SKU. Galite tęsti, bet kai kurios prekės gali būti neprieinamos.',
    skuNotFound: 'SKU nerastas duomenų bazėje',
    skusNotFound: '{count} SKU nerasti duomenų bazėje',
    itemsHaveInsufficientStock: '{count} prekės neturi pakankamai atsargų',
    validatingSKUs: 'Tikrinamos prekės...',
    unvalidatedChanges: 'Turite nepatikrintų pakeitimų. Patikrinkite prieš pridėdami į krepšelį.',
    revalidate: 'Pakartotinai patikrinti',
    validating: 'Tikrinama...',
    validationSuccess: 'Visos prekės tinkamos',
    validationComplete: 'Tikrinimas baigtas',
    validationResultSummary: '{errors} klaidų, {warnings} įspėjimų rasta',
    // Table headers
    actions: 'Veiksmai',
    notes: 'Pastabos',
    // Status filter
    all: 'Visos',
    hasErrors: 'Su klaidomis',
    // Selection summary
    selected: 'pasirinkta',
    errors: 'klaidos',
    // Pagination
    page: 'Puslapis {current} iš {total}',
    previous: 'Ankstesnis',
    next: 'Kitas',
    noResults: 'Nėra rezultatų.',
    // Cart integration
    noValidItems: 'Nėra tinkamų prekių',
    allItemsHaveErrors: 'Visos prekės turi tikrinimo klaidų. Ištaisykite jas prieš tęsdami.',
    dataLoadingError: 'Duomenų įkėlimo klaida',
    failedToLoadProductData: 'Nepavyko įkelti produktų duomenų. Bandykite dar kartą.',
    itemsAddedToCart: '{count} prekės pridėtos į krepšelį',
    itemsAddedMessage: 'Pridėta {count} prekių į krepšelį',
    someSkusNotFound: '{count} SKU nepavyko rasti.',
    noItemsAdded: 'Prekės nepridėtos',
    couldNotFindProducts: 'Nepavyko rasti produktų atitinkančių SKU.',
    errorAddingToCart: 'Klaida',
    failedToAddToCart: 'Nepavyko pridėti prekių į krepšelį. Bandykite dar kartą.',
    addingToCart: 'Pridedama į krepšelį...',
    // File info
    fileSelected: '{name} pasirinktas apdorojimui',
    fileSize: '{size} baitai',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Šablono atsisiuntimas',
    templateWillBeImplemented: 'Šablono atsisiuntimas bus įgyvendintas 7 fazėje',
    // Additional validation
    validationFailed: 'Tikrinimas nepavyko',
    // Template download
    templateDownloaded: 'Šablonas sėkmingai atsisiųstas',
    templateDownloadError: 'Nepavyko atsisiųsti šablono',
    // Template content
    sheetName: 'Masinis užsakymas',
    instructionsSheetName: 'Instrukcijos',
    columnDescriptions: 'Stulpelių aprašymai:',
    columnHeader: 'Stulpelis',
    columnRequired: 'Privalomas',
    columnOptional: 'Neprivalomas',
    columnDescription: 'Aprašymas',
    templateNotes: 'Pastabos:',
    templateNote1: 'Pirmoje eilutėje turi būti stulpelių antraštės tiksliai kaip parodyta',
    templateNote2: 'Duomenys prasideda nuo 2 eilutės',
    templateNote3: 'SKU turi atitikti esamus produktų kodus sistemoje',
    templateNote4: 'Kiekis turi būti teigiamas sveikasis skaičius nuo 1 iki 9999',
    templateNote5: 'Maksimaliai 1000 eilučių viename faile',
    templateNote6: 'Išsaugokite .xlsx arba .csv formatu',
    stockAvailabilityWarning: 'Faktinės atsargos bus patikrintos kitame atsiskaitymo puslapyje.',
    outOfStock: 'Išparduota',
    insufficientStock: 'Nepakankamos atsargos: {available} turima, {requested} prašoma',
  },
  orderExport: {
    export: 'Eksportuoti užsakymą',
    exportOrder: 'Eksportuoti užsakymo duomenis',
    exportAsCSV: 'Eksportuoti kaip CSV',
    exportAsExcel: 'Eksportuoti kaip Excel',
    exportForReorder: 'Eksportuoti masiniam importui',
    detailed: 'Visa informacija',
    simpleFormat: 'Importo formatas',
  },
};